/*
 * Catalog of available cover backgrounds.
 * Five hand-picked covers, imported as static assets so webpack hashes them.
 */

import cover1 from '../../assets/cover/1.jpg';
import cover2 from '../../assets/cover/2.jpg';
import cover3 from '../../assets/cover/3.jpg';
import cover4 from '../../assets/cover/4.jpg';
import cover5 from '../../assets/cover/5.jpg';

export interface CoverEntry {
  id: string;
  url: string;
}

export const coverCatalog: CoverEntry[] = [
  { id: 'cover-1', url: cover1 },
  { id: 'cover-2', url: cover2 },
  { id: 'cover-3', url: cover3 },
  { id: 'cover-4', url: cover4 },
  { id: 'cover-5', url: cover5 },
];

export const coverById = (id: string | null | undefined): CoverEntry | undefined =>
  id ? coverCatalog.find((c) => c.id === id) : undefined;

export const coverByValue = (value: string | null | undefined): CoverEntry | undefined => {
  if (!value) return undefined;
  return coverCatalog.find((c) => c.id === value || c.url === value);
};

export const defaultCover: CoverEntry = coverCatalog[0];
